import store from "@/store";
import router from "@/router";
import {MessageBox, Message} from 'element-ui'
import {Dialog, Toast} from 'vant';
import MD5 from 'js-md5'
import {REQUEST_TYPE_YXB} from "@/config";

export const TOAST = {
    success: 'success',
    error: 'error'
}

export const loading = (msg = '正在加载...') => {
    Toast.loading({message: msg, forbidClick: true,duration:0});
}
export const loaded = () => {
    Toast.clear()
}

export const toast = (msg, type = TOAST.success) => {
    if (browserRedirect() === 1) {
        Toast(msg)
    } else {
        if (type === TOAST.success) {
            Message.success({message: msg, duration: 2500})
        } else {
            Message.error({message: msg, duration: 2500})
        }
    }
}

export const confirm = (title, msg, fn, confirmButtonText = '确认', showCancelButton = false,cancel = ()=>{}) => {
    if (browserRedirect() === 1) {
        Dialog.confirm({
            title: title,
            message: msg,
            confirmButtonText: confirmButtonText,
            showCancelButton: showCancelButton
        }).then(() => {
            fn()
        }).catch(()=>{
            cancel()
        })
    } else {
        MessageBox.confirm(
            msg, title, {
                confirmButtonText: confirmButtonText,
                type: 'warning',
                showClose: false,
                showCancelButton: showCancelButton,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                dangerouslyUseHTMLString: true
            }
        ).then(() => {
            fn()
        }).catch(()=>{
            cancel()
        })
    }
}


export const loginTimeOut = () => {
    confirm('系统提示', '登录状态已过期，请您重新登录', logout, '重新登录')
}

export const userLogout = () => {
    confirm('退出登录', '你确定退出当前帐号吗？', logout, '退出',true)
}

export const logout = () => {
    window.localStorage.clear()
    store.dispatch('LogOut').then(() => {
        router.replace('/web/login')
    })
}

export const downloadFile = (data,fileName) =>{
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}

/**
 * 获取Token
 */
export const getToken = (type) => {
    let user = JSON.parse(window.localStorage.getItem('user'))
    return user ? {mid: type === REQUEST_TYPE_YXB ? user.mid : user.midToken} : '';
}

export const getAvatarName = (name) => {
    return name.substr(Math.max(name.length,2)-2,2)
}
export const getAvatarColor = (name) => {
    return '#' + parseInt(name.charCodeAt(0), 25).toString(16).slice(1,4)
}

export const getQNFileName = (name) => {
    return `2022_${name}`
}
export const getQNFileKey = (name) => {
    return `prj/2022_${new Date().getTime()}${name}`
}

const wxsdk = require('jweixin-module')
export const shareWx =(data,_title,_url,_image,_summary)=>{
    wxsdk.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature.toLowerCase(), // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
    });
    wxsdk.ready(function() {
        //获取“分享给朋友”按钮点击状态及自定义分享内容接口(即将废弃)
        wxsdk.updateAppMessageShareData({
            title: _title, // 分享标题
            desc: _summary, // 分享描述
            link: _url, // 分享链接
            imgUrl: _image, // 分享图标
            success: function() {
                // 用户确认分享后执行的回调函数
            },
            cancel: function() {
                // 用户取消分享后执行的回调函数
            }
        });

        //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口(即将废弃)
        wxsdk.updateTimelineShareData({
            title: _title, // 分享标题
            desc: _summary, // 分享描述
            link: _url, // 分享链接
            imgUrl: _image, // 分享图标
            success: function() {
                // 用户确认分享后执行的回调函数
            },
            cancel: function() {
                // 用户取消分享后执行的回调函数
            }
        });
    });
}

/*
* 数据过滤全部
* */
export const formatHtml = (str,replace = '') => {
    const pattern = /<(\S*?)[^>]*>.*?|<.*? > /ig
    return str.replace(pattern,replace).replace(/&nbsp;/ig, "")
}

export const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return null;
}

export const filterDate = (time) => {
    return time === '0000-00-00' ? '' : time
}

export const tipAdd = (id,tips='创建') => {
    return id ? '修改' : tips
}

export const md5 = (str) => {
    return MD5(str).substr(8, 16).toUpperCase()
}

/*
* 时间转换
* */
export const zhDate = (date, type) => {
    let now = new Date(date)
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    let second = now.getSeconds()
    if (type === 1) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
    } else if (type === 2) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
    } else if (type === 3) {
        return getzf(hour) + ":" + getzf(minute)
    } else if (type === 4) {
        return year
    }  else if (type === 5) {
        return year + "-" + getzf(month)
    } else {
        return year + "-" + getzf(month) + "-" + getzf(day)
    }
}


function getzf(num) {
    if (parseInt(num) < 10) {
        num = '0' + num
    }
    return num
}

export const browserRedirect = () => {   //  1 手机 2 pc
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = sUserAgent.match(/midp/i) == "midp";
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return 1
    } else {
        return 2
    }
}

export const _isMobile = () => {   //  1 手机 2 pc
    return browserRedirect() === 1
}

/**
 * form表单验证 提示错误信息 跳转到第一条错误的位置
 * @param validates this.$refs[formName].validate((valid, validates) => {
          if (valid) {
              this.submitChange()
          } else {
              scrollIntoView(this, validates)
          }
      });
 */
export const scrollIntoView = (_this, validates) => {
    let error = Object.values(validates).shift().shift()
    let refs = _this.$refs[error.field.split('.').join('')]
    let dom = refs instanceof Array ? refs[0] : refs
    _this.$confirm(error.message, "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "warning",
    }).then(() => {
        dom.$el.scrollIntoView({
            block: 'center', // 当前元素显示在视图区域中间
            behavior: 'auto' // 滚动速度
        })
    })
}

export const setPath = (chinese, eng, url) => {
    return {
        chinese,
        eng,
        url
    }
}

/**
 * 数据过滤全部
 * @param {*} index
 * @param {*} arr
 * @returns
 */
export const slice = (arr, index = 1) => {
    return arr.slice(index)
}
export const splice = (arr, index = 1) => {
    return arr.splice(index)
}

export const wxOauth2Url = ()=>{
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=${location.origin}${location.pathname}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}